const $ = jQuery.noConflict();

'use strict';

const ProductPGallery = {

	perPage: null,
	$dropdown: null,
	$loadMoreBtn: null,
	$cardsContainer: null,
	$containerLoader: null,
	currentFilter: '',
	visibleCount: 0,

	init: function() {
		if ($('.js-product-gallery').length === 0) {
			return;
		}
		this.initValues();
		this.bindEvents();
		this.updateDisplay();
	},

	initValues: function(){
		ProductPGallery.perPage = window.fwsPerPage;
		ProductPGallery.$dropdown = $('.js-filter-dropdown');
		ProductPGallery.$loadMoreBtn = $('.js-load-more');
		ProductPGallery.$cardsContainer = $('.js-posts-container');
		ProductPGallery.$containerLoader = $('.js-container-loader');
		ProductPGallery.currentFilter = '';
		ProductPGallery.visibleCount = ProductPGallery.perPage;
	},

	bindEvents: function() {
		// Dropdown filter
		if (ProductPGallery.$dropdown.length) {
			ProductPGallery.$dropdown.on('change select2:select', function() {
				ProductPGallery.currentFilter = $(this).val();
				ProductPGallery.visibleCount = ProductPGallery.perPage;
				ProductPGallery.updateDisplay(true);
			});
		}
		// Load More
		if (ProductPGallery.$loadMoreBtn.length) {
			ProductPGallery.$loadMoreBtn.on('click', function() {
				ProductPGallery.visibleCount += ProductPGallery.perPage;
				ProductPGallery.updateDisplay(false);
			});
		}
	},

	showLoader: function() {
		ProductPGallery.$containerLoader.addClass('is-active');
	},

	hideLoader: function() {
		ProductPGallery.$containerLoader.removeClass('is-active');
	},

	getFilteredCards: function() {
		const $allCards = ProductPGallery.$cardsContainer.find('.js-card');

		if (!ProductPGallery.currentFilter) {
			return $allCards;
		}

		return $allCards.filter(function() {
			const terms = $(this).attr('data-terms');

			if (!terms) {
				return false;
			}

			const termIds = terms.split(',');
			return termIds.includes(ProductPGallery.currentFilter);
		});
	},

	updateDisplay: function(showLoadingState = false) {
		if (showLoadingState) {
			ProductPGallery.showLoader();
		}

		setTimeout(function() {
			const $filteredCards = ProductPGallery.getFilteredCards();
			const $allCards = ProductPGallery.$cardsContainer.find('.js-card');

			$allCards.hide();

			$filteredCards.each(function(index) {
				if (index < ProductPGallery.visibleCount) {
					$(this).show();
				}
			});

			if (ProductPGallery.$loadMoreBtn.length) {
				if ($filteredCards.length > ProductPGallery.visibleCount) {
					ProductPGallery.$loadMoreBtn.parent().show();
				} else {
					ProductPGallery.$loadMoreBtn.parent().hide();
				}
			}

			if (showLoadingState) {
				ProductPGallery.hideLoader();
			}
		}, showLoadingState ? 300 : 0);
	},

};

export default ProductPGallery;
